<template>
    <div class="class condiciones0">                  
        <b-container class="mt-3">
            <div class="row mt-3">
                <div class="tab-content col-10 mx-auto pt-4" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="manual-operativo" role="tabpanel"
                        aria-labelledby="manual-operativo-tab">
                        <!-- Comienzo cajas manuales e instrucciones -->
                        <div class="container-grid">
                            <a href="pdf/manual.operativo.especial.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="font-weight-bold">Manual Operativo</div>
                                        <div>Programa Especial Edad de Oro</div>
                                    </div>
                                </div>
                            </a>
                            <a href="pdf/manual.informatica.especial.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">                                        
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="font-weight-bold">Manual Aplicación Informática</div>
                                        <div>Programa Especial Edad de Oro</div>
                                    </div>
                                </div>
                            </a>
                            <a href="pdf/normas.generales.especial.pdf" target="_blank">
                                <div class="box d-flex lift p-3">
                                    <div class="box-icon">                                        
                                        <img :src="require('@/assets/css/img/icon-pdf.svg')" alt="">
                                    </div>
                                    <div class="box-content ml-2">
                                        <div class="font-weight-bold">Otras informaciones</div>
                                        <div>Normas generales</div>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <!-- Fin cajas manuales e instrucciones -->
                    </div>
                </div>
            </div>
        </b-container>  
    </div>      
</template>

<script>

//import MenuOpcion from '@/components/MenuOpcion.vue'

export default {
    name: 'manuales ',
    components: {
        //MenuOpcion,
    },

    data() {
        return {
            titulo: "MANUAL OPERATIVO",
        }
    },
    
}
</script>